import { ID } from './id';

export enum LinkedItemType {
  Goal = 'goal',
  LifeArea = 'lifeArea',
  AllTasks = 'allTasks',
}

// Sentinel linked-item id for the all-tasks sync: keys calendarSettings where a goal/life-area
// would, so the whole sync machinery treats it like any other target. Backend mirrors this value.
export const ALL_TASKS_LINKED_ITEM_ID: ID = 'all-tasks';
